/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FolderCreate interface.
 */
export function instanceOfFolderCreate(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
export function FolderCreateFromJSON(json) {
    return FolderCreateFromJSONTyped(json, false);
}
export function FolderCreateFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
    };
}
export function FolderCreateToJSON(json) {
    return FolderCreateToJSONTyped(json, false);
}
export function FolderCreateToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
    };
}
